module.exports = __webpack_public_path__ + "static/media/react.81ceca3c.png";